import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import styled from "styled-components"

const Container = styled.div`
  display: flex;
  @media screen and (max-width: 375px) {
    display: block;
    text-align: center;
  }
`

const Header = ({ lang, siteTitle }) => (
  <header
    style={{
      marginBottom: `1.45rem`,
    }}
  >
    <Container
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottom: "1px solid rgb(219, 219, 216)",
      }}
    >
      <h1 style={{ margin: 0, fontSize: 22 }}>
        <Link
          to={lang === "ko" ? "/ko/" : "/"}
          style={{
            textDecoration: `none`,
          }}
        >
          {siteTitle}
          <span
            style={{
              color: "#333333",
              letterSpacing: -0.5,
              fontSize: 12,
              marginLeft: 3,
            }}
          >
            {" by Yong"}
          </span>
        </Link>
      </h1>
      <div>
        <Link to={"/"} className={"lang-link"}>
          🇺🇸 English
        </Link>
        <Link to={"/ko/"} className={"lang-link"}>
          🇰🇷 한국어
        </Link>
      </div>
    </Container>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
